<script setup lang="ts">
import MailboxPanel from '@/components/MailboxPanel.vue'
import { myMailboxSource } from '@/lib/mailboxSources'

/**
 * The signed-in person's own mailbox (#887), on Inbox: the shared mailbox panel over `/v1/mail` (`myMailboxSource`),
 * with every command the person may give their own mail. Given `emailId`, the one mail on the whole page.
 */
defineProps<{ emailId?: string }>()
const emit = defineEmits<{ changed: [] }>()

const source = myMailboxSource()
</script>

<template>
	<MailboxPanel :source="source" own :email-id="emailId" data-testid="my-mail" @changed="emit('changed')" />
</template>
